import { AuthState } from '@app/interfaces/auth';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectToken = createSelector(
  selectAuthState,
  (state) => state.token
);

export const selectAuthLoading = createSelector(
  selectAuthState,
  (state) => state.loading
);

export const selectAuthError = createSelector(
  selectAuthState,
  (state) => state.error
);

export const selectIsTokenValid = createSelector(
  selectToken,
  (token) => {
    if (!token) return false;
    
    const now = Date.now();
    const tokenExpirationTime = token.obtained_at + (token.expires_in * 1000);
    
    // Considerar válido si falta más de 5 minutos para expirar
    return tokenExpirationTime > (now + 300000); // 5 minutos de buffer
  }
);

export const selectValidToken = createSelector(
  selectToken,
  selectIsTokenValid,
  (token, isValid) => isValid ? token : null
);